import ServerIcon from '../../../../images/server.svg?component';
import ROUTE_NAMES from '../../routeNames';
import SECTION_NAMES from '../../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.SERVERS_AND_SERVICES,
    icon: ServerIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminServersLdapServers],
};

const AdminLdapServerForm = (): Promise<unknown> => import('../../../views/admin/Servers/Ldap/AdminLdapServerForm.vue');

export default [
    {
        path: '',
        name: ROUTE_NAMES.ADMIN_LDAP_SERVER_LIST,
        component: ():Promise<unknown> => import('../../../views/admin/Servers/Ldap/AdminLdapServerTable.vue'),
        meta,
    },
    {
        path: 'edit/:id',
        name: ROUTE_NAMES.ADMIN_LDAP_SERVER_VIEW,
        component: AdminLdapServerForm,
        meta,
    },
    {
        path: 'new',
        name: ROUTE_NAMES.ADMIN_LDAP_SERVER_NEW,
        component: AdminLdapServerForm,
        meta,
    },
];
